/** @file BulkDialogs: the bulk upload's fit prompt and result dialog, whichever is due. */
import type { ReactElement } from 'react';
import { BulkFitPrompt } from './BulkFitPrompt';
import { BulkResultDialog } from './BulkResultDialog';
import type { BulkUpload } from './useBulkUpload';

/** The flow whose dialogs are shown. */
export type BulkDialogsProps = { bulk: BulkUpload };

/** The Pad / Scale / Skip prompt while files wait for a fit, else the report once the batch is done. */
export function BulkDialogs({ bulk }: BulkDialogsProps): ReactElement | null {
  if (bulk.pending !== null) return <BulkFitPrompt misfits={bulk.pending.misfits} choose={(fit) => { void bulk.choose(fit); }} />;
  return bulk.result === null ? null : <BulkResultDialog outcome={bulk.result} onClose={bulk.closeResult} />;
}
